import {
  Card,
  Col,
  Progress,
  Radio,
  Row,
  Select,
  Skeleton,
  Tabs,
  Typography,
  Descriptions,
  Table,
  Tag,
  Badge,
  Tooltip,
  Input,
  Menu,
  Button,
} from "antd";
 

import { DownOutlined, UndoOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend,  BarChart, Bar, Rectangle , ResponsiveContainer } from "recharts";

import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { useAuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import lang from "../../helper/langHelper";
import "../../assets/styles/dashboard.css";
import moment from "moment";
import ImportForm from "../../components/ImportForm";

import Plus from "../../assets/images/plus.svg";

import NewHeader from "../../components/layout/NewHeader";
import SectionWrapper from "../../components/SectionWrapper";

const { Title, Text } = Typography;

const years = [2024, 2025];

function NewChallenge() {
  const { setPageHeading } = useContext(AppStateContext);

  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(years[0]);
  const { userProfile } = useAuthContext();
  const [dashboard, setDashboard] = useState();
  const [listing, setListing] = useState([]);

  const count = [
    {
      today: "Number of Customers",
      title: `${dashboard?.totalCustomer || 0}`,

      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      url: "/customer",
      key: "customer-manager",
    },
    {
      today: "Number of Challenges",
      title: `${dashboard?.totalOrders || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: "/order",
      key: "order-manager",
    },
    {
      today: "Number of Rewards Redeemed",
      title: `${dashboard?.totalOrders || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: "/order",
      key: "order-manager",
    },
    {
      today: "Number of Products",
      title: `${dashboard?.totalOrders || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: "/order",
      key: "order-manager",
    },
  ];

  const orders = [
    {
      title: "Order id",
      dataIndex: "index",
      key: "index",
      render: (_, { order_id }) =>
        order_id ? <span className="cap">#{order_id}</span> : "-",
    },
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      render: (_, { user_id }) =>
        user_id ? (
          <div style={{ display: "flex", gap: 2, flexDirection: "column" }}>
            {user_id?.name && <span className="cap">{user_id.name}</span>}
            {user_id?.country_code && user_id?.mobile_number && (
              <span className="cap" style={{ fontSize: "14px", color: "gray" }}>
                (
                {user_id.country_code?.includes("+")
                  ? user_id.country_code
                  : "+" + user_id.country_code}
                ) {user_id.mobile_number}
              </span>
            )}
            {user_id?.email && (
              <span style={{ fontSize: "14px", color: "gray" }}>
                {user_id.email}
              </span>
            )}
          </div>
        ) : (
          "-"
        ),
      sorter: (a, b) => {
        let nameA = a.user_id?.name;
        let nameB = b.user_id?.name;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      key: "amount",
      render: (_, { amount }) => (
        <span className="cap">{amount?.toFixed(2) ?? 0.0}</span>
      ),
      sorter: (a, b) => {
        let nameA = a.amount;
        let nameB = b.amount;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    }, 
  ];

  const data01 = [
    {
      name: 'A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ]

  const data02 = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];


  useEffect(() => {
    setPageHeading("Welcome Admin");
    if (!userProfile) return;

    setLoading(true);
    request({
      url: apiPath.dashboard + `${year ? `?year=${year}` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setListing(data?.orders);
        setDashboard(data?.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [userProfile]);


  return (
    <>
      <div className="dashboard-section">
        <div className="container">
          <div className="main-card-section">
            <NewHeader />
            <Card className="criclebox mt-3">
              <div className="table-header-top">
                <div className="userid-no">
                  <h6>User Id</h6>
                </div>
                <div className="right-outer-header">
                  <Button className="primary_btn btnStyle">
                    {lang("challenges managers ")}
                  </Button>
                </div>
              </div>
              <Row gutter={[12, 12]}>
                <Col span={24} lg={12}>
                  <Card className="table-card mt-3">
                    <div className="card-headered">
                      <div className="card-headding">
                        <h6>Admin Challenges Creative</h6>
                      </div>
                      <div className="w-100 text-head_right_cont">
                        <div className="pageHeadingSearch pageHeadingSearchmain-yy">
                          <Input.Search
                            allowClear={true}
                            className="searchInput"
                            placeholder={lang("Search by role")}
                          />
                        </div>
                        <Button className="primary_btn btnStyle">
                          <span className="add-Ic">
                            <img src={Plus} />
                          </span>
                          {lang("Add")}
                        </Button>
                      </div>
                    </div>
                    <div className="table-responsive customPagination">
                      <Table
                        loading={loading}
                        columns={orders}
                        dataSource={listing}
                        pagination={false}
                        className="ant-border-space"
                      />
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={12}>
                  <Card className="table-card mt-3">
                    <div className="card-headered">
                      <div className="card-headding">
                        <h6>Admin Challenges Creative</h6>
                      </div>
                      <div className="w-100 text-head_right_cont">
                        <div className="pageHeadingSearch pageHeadingSearchmain-yy">
                          <Input.Search
                            allowClear={true}
                            className="searchInput"
                            placeholder={lang("Search by role")}
                          />
                        </div>
                        <Button className="primary_btn btnStyle">
                          <span className="add-Ic">
                            <img src={Plus} />
                          </span>
                          {lang("Add")}
                        </Button>
                      </div>
                    </div>
                    <div className="table-responsive customPagination">
                      <Table
                        loading={loading}
                        columns={orders}
                        dataSource={listing}
                        pagination={false}
                        className="ant-border-space"
                      />
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={18}>
                  <Card className="table-card mt-3">
                    <Row gutter={[12, 12]}>
                      <Col span={24} lg={12}>
                        <ResponsiveContainer width={"100%"} height={300}>
                          <BarChart
                            data={data01}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar
                              dataKey="uv"
                              fill="#B3CDAD"
                              activeBar={
                                <Rectangle fill="pink" stroke="blue" />
                              }
                            />
                            <Bar
                              dataKey="pv"
                              fill="#FF5F5E"
                              activeBar={
                                <Rectangle fill="gold" stroke="purple" />
                              }
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col span={24} lg={12}>
                        <ResponsiveContainer width={"100%"} height={300}>
                          <BarChart
                            data={data01}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar
                              dataKey="uv"
                              fill="#B3CDAD"
                              activeBar={
                                <Rectangle fill="pink" stroke="blue" />
                              }
                            />
                            <Bar
                              dataKey="pv"
                              fill="#FF5F5E"
                              activeBar={
                                <Rectangle fill="gold" stroke="purple" />
                              }
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={24} lg={6}>
                  <Card className="table-card mt-3">
                    <div className="count-box-main">
                      <div class="user-counter-box">
                        <h4>Total active users</h4>
                        <div class="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div class="user-counter-box">
                        <h4>Total active users</h4>
                        <div class="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div class="user-counter-box">
                        <h4>Total active users</h4>
                        <div class="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div class="user-counter-box">
                        <h4>Total active users</h4>
                        <div class="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={8}>
                  <Card className="table-card mt-3">
                    <div className="card-headered">
                      <div className="card-headding">
                        <h6>Admin Challenges Creative</h6>
                      </div>
                      {/* <div className="w-100 text-head_right_cont">
                            <div className="pageHeadingSearch pageHeadingSearchmain-yy">
                            <Input.Search
                                allowClear={true}
                                className="searchInput"
                                placeholder={lang("Search by role")}
                            />
                            </div>
                            <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                                <img src={Plus} />
                            </span>
                            {lang("Add")}
                            </Button>
                        </div> */}
                    </div>
                    <div className="table-responsive customPagination">
                      <Table
                        loading={loading}
                        columns={orders}
                        dataSource={listing}
                        pagination={false}
                        className="ant-border-space"
                      />
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={8}>
                  <Card className="table-card mt-3">
                    <div className="card-headered">
                      <div className="card-headding">
                        <h6>Admin Challenges Creative</h6>
                      </div>
                      {/* <div className="w-100 text-head_right_cont">
                            <div className="pageHeadingSearch pageHeadingSearchmain-yy">
                            <Input.Search
                                allowClear={true}
                                className="searchInput"
                                placeholder={lang("Search by role")}
                            />
                            </div>
                            <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                                <img src={Plus} />
                            </span>
                            {lang("Add")}
                            </Button>
                        </div> */}
                    </div>
                    <div className="table-responsive customPagination">
                      <Table
                        loading={loading}
                        columns={orders}
                        dataSource={listing}
                        pagination={false}
                        className="ant-border-space"
                      />
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={8}>
                  <Card className="table-card mt-3">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart
                        width={500}
                        height={300}
                        data={data02}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="pv"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                        />
                        <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                      </LineChart>
                    </ResponsiveContainer>
                  </Card>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewChallenge;
